

import {PublisherDataPointCards} from "./Container/publisherDataPointCards";
export default  PublisherDataPointCards;